// extracted by mini-css-extract-plugin
module.exports = {"chart":"WorldNodes_chart__27XTE","chart_title":"WorldNodes_chart_title__3Tiq5"};